//https://tom-select.js.org/
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.min.css";

window.addEventListener('load', function () {
    //Recherche par code postal sur la page d'accueil (-with-redirection) et sur le formulaire de pre-inscription
    let rechercheParCodePostalSelectElement = document.querySelector('.js-recherche-code-postal');

    let clearButton = document.getElementById('clear-recherche');

    let inDepartment = document.querySelector('.research-from-department');

    if (rechercheParCodePostalSelectElement != null) {
        //Récupérer l'URL pour l'Ajax de WordPress, cette URL est passé en data du champ de recherche
        let adminAjaxUrl = rechercheParCodePostalSelectElement.getAttribute('data-admin-ajax-url');
        let defaultId = rechercheParCodePostalSelectElement.getAttribute('data-default-id');
        let defaultPostcode = rechercheParCodePostalSelectElement.getAttribute('data-default-postcode');
        let defaultCity = rechercheParCodePostalSelectElement.getAttribute('data-default-city');

        //Créer l'autocomplete
        if(rechercheParCodePostalSelectElement.classList.contains('-with-redirection')) {
            //Lorsque l'utilisateur choisi un résultat dans la recherche (sur la page d'accueil/complexe) :
            //On affiche les missions locales dans les résultats et on redirige vers une URL
            let tomSelectControl = new TomSelect(rechercheParCodePostalSelectElement, {
                sortField: 'city',
                valueField: 'id',
                labelField: 'city',
                searchField: ['postcode', 'city'],
                maxOptions: 100,
                maxItems: 1,
                //Déclencher l'AJAX
                //TODO Mutualiser ?
                load: function (query, callback) {

                    if (!query.length || query.length < 2) {
                        return callback();
                    }
                    //https://tom-select.js.org/examples/remote/ (Load Once)
                    let self = this;
                    //Déclencher l'appel qu'une fois
                    // if (self.loading > 1) {
                    //     callback();
                    //     return;
                    // }

                    //Appel Ajax WordPress
                    const data = new FormData();
                    //Définition de l'action à déclencher (ajax_communes est défini dans Bootstrap.php)
                    data.append('action', 'ajax_actionscope');
                    data.append('keyword', query);

                    fetch(adminAjaxUrl, {
                        method: "POST",
                        body: data
                    })
                    .then(response => response.json())
                    .then(json => {

                        // Filtrage par département si nécessaire
                        let results = inDepartment
                            ? json.filter(item =>
                                item.postcode && item.postcode.startsWith(
                                    inDepartment.getAttribute('data-department')
                                )
                            )
                            : json;

                        callback(results);

                    })
                    .catch(() => {
                        callback();
                    });
                },
                render: {
                    //Item (quand il sera sélectionné)
                    item: function (data, escape) {
                        return `<div id="selected-search-element" data-id="${escape(data['id'])}" data-url="${escape(data['url'])}">
                            ${escape(data['city'])} (${escape(data['postcode'])})
                        </div>`;
                    },
                    //Affichage dans la liste à sélectionner
                    option: function (data, escape) {
                        return `<div class="select-resultat">
                            <span class="ville">${escape(data['city'])} (${escape(data['postcode'])})</span>
                            <span class="mission-locale">${escape(data['name'])}</span>
                        </div>`;
                    },
                    no_results: function (data, escape) {
                        return '<div class="no-results">Aucun résultat trouvé</div>';
                    },
                },
                //Lorsqu'unn item est sélectionné
                onItemAdd: function (value, $item) {
                    //Récupération de l'URL (défini en data dans item) sur laquelle on doit rediriger l'utilisateur
                    window.open($item.getAttribute('data-url'), '_blank');
                }
            });

            const tsInput = tomSelectControl.control_input;

            tsInput.addEventListener('input', function () {
                // Si un item est déjà sélectionné → on le supprime
                if (tomSelectControl.items.length > 0) {
                    tomSelectControl.clear();
                }
            });

            if (clearButton && tomSelectControl) {

                const toggleClearButton = () => {
                    const hasText =
                        tomSelectControl.control_input.value.length > 0 ||
                        tomSelectControl.items.length > 0;

                    clearButton.style.display = hasText ? 'block' : 'none';
                };

                clearButton.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Vider la sélection
                    tomSelectControl.clear();

                    // Optionnel : vider les options chargées
                    tomSelectControl.clearOptions();

                    // Redonner le focus à l’input
                    tomSelectControl.focus();

                    toggleClearButton();
                });

                tsInput.addEventListener('input', toggleClearButton);
            }
        } else {
            let tomSelectControl = new TomSelect(rechercheParCodePostalSelectElement, {
                sortField: 'city',
                valueField: 'id',
                labelField: 'city',
                searchField: ['postcode', 'city'],
                maxOptions: 100,
                maxItems: 1,
                plugins: {
                    remove_button:{
                        title:'Retirer',
                    }
                },
                //Déclencher l'AJAX
                //TODO Mutualiser ?
                load: function (query, callback) {

                    if (!query.length || query.length < 2) {
                        return callback();
                    }
                    //https://tom-select.js.org/examples/remote/ (Load Once)
                    let self = this;
                    //Déclencher l'appel qu'une fois
                    // if (self.loading > 1) {
                    //     callback();
                    //     return;
                    // }

                    //Appel Ajax WordPress
                    const data = new FormData();
                    //Définition de l'action à déclencher (ajax_communes est défini dans Bootstrap.php)
                    data.append('action', 'ajax_actionscope');
                    data.append('keyword', query);

                    fetch(adminAjaxUrl, {
                        method: "POST",
                        body: data
                    })
                        .then(response => response.json())
                        .then(json => {
                            callback(json);
                        }).catch(() => {
                        callback();
                    });
                },
                render: {
                    //Item (quand il sera sélectionné)
                    item: function (data, escape) {
                        return `<div data-id="${escape(data['id'])}" data-city="${escape(data['city'])}" data-postcode="${escape(data['postcode'])}">
                            ${escape(data['city'])} (${escape(data['postcode'])})
                        </div>`;
                    },
                    //Affichage dans la liste à sélectionner
                    option: function (data, escape) {
                        return `<div class="select-resultat">
                            <span class="ville">${escape(data['city'])} (${escape(data['postcode'])})</span>
                        </div>`;
                    },
                    no_results: function (data, escape) {
                        return '<div class="no-results">Aucun résultat trouvé</div>';
                    },
                }
            });

            if(defaultId != null) {
                //Source : https://github.com/orchidjs/tom-select/discussions/240#discussioncomment-4153170
                //tomSelectControl.addOption({ id: 0, city: 'Rechercher un code postal', postcode: 'ou une ville'});
                tomSelectControl.addOption({ id: defaultId, city: defaultCity, postcode: defaultPostcode});
                tomSelectControl.addItem(defaultId);
            }

            const tsInput = tomSelectControl.control_input;

            if (clearButton && tomSelectControl) {

                const toggleClearButton = () => {
                    const hasText =
                        tomSelectControl.control_input.value.length > 0 ||
                        tomSelectControl.items.length > 0;

                    clearButton.style.display = hasText ? 'block' : 'none';
                };

                clearButton.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Vider la sélection
                    tomSelectControl.clear();

                    // Optionnel : vider les options chargées
                    tomSelectControl.clearOptions();

                    // Redonner le focus à l’input
                    tomSelectControl.focus();

                    toggleClearButton();
                });

                tsInput.addEventListener('input', toggleClearButton);
            }
        }
    }

}, false);
